/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */

/**
 * Constants for GTM component
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.1.0
 */

export enum EGTMAccountType {
    CREDIT = 'credit',
    EMPTY = '(empty)',
    PREPAID = 'prepayment',
}

export const PUSH_GTM_ANALYTIC = '@@b2b_portal_ui/analytic/PUSH_GTM_ANALYTIC';
